/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import {Group, DataStorage, EEmbededElementTypes, RenderDocument} from "js_renderer";
import {vec2, vec3} from "gl-matrix";
import Factory from "../factory";
import GeoEntity from "./geo_entity";
import {importWatterImage} from "App/dynamic_import";

export default
class WaterEntity extends GeoEntity {

    public static TypeIcon: HTMLImageElement = new Image();
    public static TypeName: string = EEmbededElementTypes.WATERENTITY;

    constructor(aRenderDocument: RenderDocument) {
        super(aRenderDocument);

        let textureUrl = '@assets/images/water.svg';
        importWatterImage().then((asset) => {
            let content =  asset.default ? asset.default : asset;
            if (content.indexOf("data:") !== -1) { // in url data
                WaterEntity.TypeIcon.src = content;
            }
            else {
                WaterEntity.TypeIcon.src = content.replace(/\\/g, "/");
            }
        });

        // default values
        this.extendProperties({
            minSize: 6.0,
            maxSize: 12.0,
            pickable: false,
            textureUrl: textureUrl
        });
    }

    public static create(aRenderDocument: RenderDocument): WaterEntity {
        let element = new WaterEntity(aRenderDocument);
        element._typeName = WaterEntity.TypeName;
        return element;
    }

    public setSize(aMinSize: number, aMaxSize: number) {
        this._properties.minPointSize = aMinSize;
        this._properties.maxPointSize = aMaxSize;
    }

    public getTypeName(): string {
        return WaterEntity.TypeName;
    }

    public getTypeIcon(): CanvasImageSource {
        return WaterEntity.TypeIcon;
    }

    public getStyle(): string {
        return "bold italic";
    }

    public getColor(): vec3 {
        return vec3.fromValues(0.561, 0.902, 0.980); // 8FE6FA        //   0.459, 0.729, 0.992   0.627, 0.816, 0.996   0.702, 0.894, 0.988
    }

// TODO: @ Jarek: the model element can contain more than one poi part, so we should generate more poi geometry for such model element
    protected _generateElementDescriptionJSON() {
        // these are model element properties taken from the scene api element properties
        return {
            "type": this._properties.type,
            "id": this.getTypeName() + "_" + this._UID,   // this is is not important in the engine, it can identify e.g. id of an element in Lexocad
            "UID": this._UID
        };
    }

// TODO: @ Jarek: the model element can contain more than one poi part, so we should generate more poi geometry for such model element
    protected _generateGeometryObjectDescriptionJSON(): any {
        let textBillboardGeometry =
            this._sceneAPI.getCanvasTextRenderer().createTextGeometry(
                this._properties.title,
                this._properties.position,
                this.getStyle(),
                this.getFontSize(),
                this.getFont(),
                this.getColor(),
                [0, 0, 0],
                WaterEntity.TypeIcon.src,
                this.getIconSize()
            );

        return [{
            description: {
                type: "TEXT2D",
                color: [0.0, 0.0, 0.0],
                bboxMin: this._properties.position,
                bboxMax: this._properties.position
            },
            pointSet: {
                src: this._renderDocument.getRenderer()._dataStorage.createLocalResourceUri(),
                vertexCount: 1,
                binSize: 12,
                points: this._properties.position
            }
        }];
        /*
         return [{
             description: {
                 type: "BILLBOARD",
                 color: [0.0, 0.0, 0.0],
                 bboxMin: [textBillboardGeometry.bbox.min[0], textBillboardGeometry.bbox.min[1], textBillboardGeometry.bbox.min[2]],
                 bboxMax: [textBillboardGeometry.bbox.max[0], textBillboardGeometry.bbox.max[1], textBillboardGeometry.bbox.max[2]]
             },
             appearance: {
                 "imageTexture": {
                     url: [textBillboardGeometry.canvasTextureUri],
                     width: [textBillboardGeometry.canvasTextureWidth],
                     height: [textBillboardGeometry.canvasTextureHeight],
                     offsets: [0],
                     sizes: [0],
                     tiled: [false],
                     alpha: true,
                     model: "REPLACE",
                     blendColor: [0.00392157, 0.00392157, 0.00392157],
                     repeatS: 0,
                     repeatT: 0
                 }
             },
             offsetedIndexedFaceSet: {
                 src: this._sceneAPI.getDocument()._renderDocument.getRenderer()._dataStorage.createLocalResourceUri(),
                 vertexCount: textBillboardGeometry.vertexCount,
                 normalCount: textBillboardGeometry.normalCount,
                 texcoordCount: textBillboardGeometry.texcoordCount,
                 indexCount: textBillboardGeometry.indexCount,
                 offset: this._properties.position,
                 binSize: 0,
                 positions: textBillboardGeometry.vertices,
                 normals: textBillboardGeometry.normals,
                 texCoords:textBillboardGeometry.texCoords,
                 indices: textBillboardGeometry.indices
             }
         }];*/
    }
}

Factory.register(WaterEntity);
